export default __webpack_public_path__ + "static/ProductSans-Medium-cc43e3c472e82f3b86190b7e0655415c.woff";